import React, { useImperativeHandle } from 'react';
import { connect } from 'react-redux';
import { useI18n } from '../../../../../i18n';
import { cx } from '../../../../api';
import { actions } from '../../../../redux/api/reports';
import Form from '../../../general/form/Form';

const BATCH_SIZE = 70;

/**
 * @param {Object} props
 * @param {React.RefObject} props.customRef
 * @param {Object} props.timeRange
 * @param {boolean} [props.disabled]
 */

function TemperatureChange(props) {
	const { f } = useI18n();

	useImperativeHandle(props.customRef, () => ({
		submit: (values) => {
			const parameters = new cx.ods.reports.TemperatureChangeReportParameters();
			parameters.timeRange = props.timeRange;
			parameters.timeRange.retrospective = values.retrospective;
			parameters.timeRange.window = new cx.ods.TimeWindow(BATCH_SIZE);
			parameters.delta = +values.delta;
			props.dispatch(actions.temperatureChange.request({ uri: values.uri, parameters, clear: true }));
		},
		clear: () => {
			props.dispatch(actions.temperatureChange.exportClear());
		}
	}));

	return (
		<Form.ControlGroup key={50} disabled={props.disabled}>
			<Form.Control
				controlName="delta"
				controlType={Form.Control.Type.Input}
				controlValidator={(value) => {
					value = parseInt(value);
					return !(Number.isInteger(value) && value > 0) && f('please enter integer number above zero');
				}}
				label={f('temperature delta', { unit: '°C' })}
				type="number"
				initialValue={props.state.parameters ? props.state.parameters.delta : 5}
			/>
			<Form.Control
				controlName="retrospective"
				controlType={Form.Control.Type.Checkbox}
				label={f('report later items first')}
				initialValue={props.state.parameters ? props.state.parameters.timeRange.retrospective : false}
			/>
		</Form.ControlGroup>
	)
}

export default connect(state => {
	return {
		state: state.reports.temperatureChange
	}
})(TemperatureChange);
